import React from "react";
import ReactDOMServer from "react-dom/server";
import { Modal, Button } from "react-bootstrap";
import { Printer } from "react-feather";
import LedgerPrintPreview from "./LedgerPrintPreview";
import { useGetBranchesQuery } from "../../../admin/adminApi";
import { useGetCompanyInfoQuery } from "../../../settings/settingsApi";

/**
 * Preview + print for the petty cash ledger (2026-09-11). Same popup pattern as
 * VoucherPrintModal / StockDocumentPrintModal: render the SAME preview component
 * to static markup, write it into a blank window, print. No PDF dependency, and
 * the table header repeats on every printed page (thead as table-header-group).
 */
const LedgerPrintModal = ({ show, onClose, fundGroups, dateFrom, dateTo, flat = false, orderLabel }) => {
  // The branch's own company name above the title (e.g. SYSTEMS -> "TEXAS
  // SYSTEMS LTD"), same source as the list exports. Only when every fund on the
  // printout belongs to one branch - otherwise each section's logo says it.
  const branchCodes = [...new Set(fundGroups.map((f) => f.branchCode))];
  const singleBranchCode = branchCodes.length === 1 ? branchCodes[0] : undefined;
  const { data: branches = [] } = useGetBranchesQuery(undefined, { skip: !show });
  const branchId = singleBranchCode ? branches.find((b) => b.branchCode === singleBranchCode)?.branchId : undefined;
  const { data: companyInfo } = useGetCompanyInfoQuery(branchId, { skip: !show || !branchId });
  const companyName = (branchId && companyInfo?.["Company.Name"]) || undefined;

  const preview = (
    <LedgerPrintPreview fundGroups={fundGroups} dateFrom={dateFrom} dateTo={dateTo} companyName={companyName} flat={flat} orderLabel={orderLabel} />
  );

  const handlePrint = () => {
    const bodyHtml = ReactDOMServer.renderToStaticMarkup(preview);
    const win = window.open("", "_blank", "width=900,height=1000");
    if (!win) return;
    win.document.write(
      `<html><head><title>Petty Cash Ledger ${dateFrom} to ${dateTo}</title>` +
        `<style>@page { size: A4; margin: 8mm; } html,body { margin:0; padding:0; } body { width: 194mm; }` +
        ` thead { display: table-header-group; } tr { page-break-inside: avoid; }</style>` +
        `</head>` +
        `<body onload="window.print();window.close();">${bodyHtml}</body></html>`
    );
    win.document.close();
  };

  return (
    <Modal show={show} onHide={onClose} size="xl" centered scrollable>
      <Modal.Header closeButton>
        <Modal.Title className="h5">
          Petty Cash Ledger
          <span className="text-muted ms-2 fs-6">preview</span>
        </Modal.Title>
      </Modal.Header>
      <Modal.Body style={{ background: "#e9ecef" }}>
        <div style={{ background: "#fff", boxShadow: "0 1px 6px rgba(0,0,0,.2)", maxWidth: "210mm", margin: "0 auto" }}>
          {preview}
        </div>
      </Modal.Body>
      <Modal.Footer>
        <Button variant="secondary" onClick={onClose}>
          Close
        </Button>
        <Button variant="primary" onClick={handlePrint} className="d-inline-flex align-items-center gap-2">
          <Printer size={16} /> Print
        </Button>
      </Modal.Footer>
    </Modal>
  );
};

export default LedgerPrintModal;
